  <!--This is a name used for styling from the dtf-accountdetailpage.scss-->
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage">
  <div class="box">
    <div class="annoucement-info_container" *ngIf="this.dbData">
      <div class="annoucement-info__toggle">
        <div class="annoucement-info-text">{{alerts.bannerHeader}}</div>
        <div class="annoucement-info_learn-more" (click)="anouncementMgsopen($event)">
          <!-- {{alerts.srvrNamePhnTab}} -->
          <a [ngClass]="this.toggleOpen ? 'annoucement-info-link-open' : 'annoucement-info-link'"></a>
        </div>
      </div>
      <div class="annoucement-info-box" *ngIf="this.toggleOpen">
        <h2 class="annoucement-info-header-title">{{alerts.bannerInsertImgUrl}}</h2>
        <p class="annoucement-info-pcontent">{{alerts.bannerCopy}}<br>
        </p>
      </div>
    </div>
  </div>

    <!--Agent View Scroller-->
    <div class="box" *ngIf="agentview==='true'">
      <div class="annoucement-info_container">
        <div class="annoucement-info__toggle">
          <marquee behavior="scroll" direction="left" class="annoucement-info-text"><b>{{ 'LoaderPages.FawScroller' | translate }}</b></marquee>
        </div>
      </div>
    </div>
  </div>
